import React, { useCallback, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';

import { useGoBack } from '../../../../../hooks/use-go-back';
import { Preloader } from '../../../../common/preloader';
import { OrderLayout } from './order-layout';
import { IOrderCreateProps } from './order-create-page.models';
import { setIsRepeatOrder, orderStore } from '../../../../../graphql/order/order.cache';
import { useEcpStoresFromCache } from '../../../../../graphql/ecp-locator/actions/ecp-stores';
import { OrderRepeatPage } from './order-repeat-page';
import { cleanupState } from './utils/cleanup-state';

export const OrderCreatePage = ({
  isError, isLoading, onDone, lensesData, brandsData,
}: IOrderCreateProps): JSX.Element => {
  const { goBack } = useGoBack();
  const handleBack = useCallback(() => goBack(), [goBack]);
  const { setEcpStoresToCache } = useEcpStoresFromCache();
  const isRepeatOrder = useReactiveVar(setIsRepeatOrder);
  const isOrderStore = useReactiveVar(orderStore);

  const renderOrderCreatePage = () => {
    if (isLoading) {
      return <Preloader />;
    }

    if (isError) {
      handleBack();
    }

    return (
      <>{isRepeatOrder ? (
        <OrderRepeatPage
          lenses={lensesData?.consumerLensesByAuthID ?? []}
          onDone={onDone}
          brandsData={brandsData}
        />
      ) : (
        <OrderLayout
          lenses={lensesData?.consumerLensesByAuthID ?? []}
          onDone={onDone}
          brandsData={brandsData}
          store={isOrderStore}
        />
      )}</>
    );
  };

  useEffect(() => {
    setEcpStoresToCache([]);

    return () => {
      cleanupState();
      setIsRepeatOrder(false);
      orderStore(null);
    };
  }, []);

  return renderOrderCreatePage();
};
